import { isMatch, replace } from "../fable_modules/fable-library.3.7.9/RegExp.js";
import { Union, Record } from "../fable_modules/fable-library.3.7.9/Types.js";
import { uint8_type, unit_type, lambda_type, int32_type, tuple_type, float64_type, option_type, bool_type, array_type, list_type, class_type, union_type, record_type, string_type } from "../fable_modules/fable-library.3.7.9/Reflection.js";
import { defaultArg } from "../fable_modules/fable-library.3.7.9/Option.js";
import { empty } from "../fable_modules/fable-library.3.7.9/Map.js";
import { exists, tryFind, empty as empty_1 } from "../fable_modules/fable-library.3.7.9/List.js";
import { fromBits } from "../fable_modules/fable-library.3.7.9/Long.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library.3.7.9/String.js";
import { tryHead } from "../fable_modules/fable-library.3.7.9/Array.js";

export function StringUtils_replace(pattern, replacement, input) {
    return replace(input, pattern, replacement);
}

export function StringUtils_truncate(maxLength, s) {
    if (s.length > (maxLength - 3)) {
        return s.slice(0, (maxLength - 3) + 1) + "...";
    }
    else {
        return s;
    }
}

export class Cwb_PositionalAttribute extends Record {
    constructor(Code, Name) {
        super();
        this.Code = Code;
        this.Name = Name;
    }
}

export function Cwb_PositionalAttribute$reflection() {
    return record_type("Shared.Cwb.PositionalAttribute", [], Cwb_PositionalAttribute, () => [["Code", string_type], ["Name", string_type]]);
}

export class Metadata_GeoMapControlType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["DiscreteControl", "IntervalControl"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "interval" : "discrete";
    }
}

export function Metadata_GeoMapControlType$reflection() {
    return union_type("Shared.Metadata.GeoMapControlType", [], Metadata_GeoMapControlType, () => [[], []]);
}

export class Metadata_GeoMapCategoryConfig extends Record {
    constructor(QualifiedColumnName, Name, ControlType) {
        super();
        this.QualifiedColumnName = QualifiedColumnName;
        this.Name = Name;
        this.ControlType = ControlType;
    }
}

export function Metadata_GeoMapCategoryConfig$reflection() {
    return record_type("Shared.Metadata.GeoMapCategoryConfig", [], Metadata_GeoMapCategoryConfig, () => [["QualifiedColumnName", string_type], ["Name", string_type], ["ControlType", Metadata_GeoMapControlType$reflection()]]);
}

export class Metadata_Category {
    constructor(aName) {
        this.aName = aName;
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return void 0;
    }
}

export function Metadata_Category$reflection() {
    return class_type("Shared.Metadata.Category", void 0, Metadata_Category);
}

export function Metadata_Category_$ctor_Z721C83C5(aName) {
    return new Metadata_Category(aName);
}

export function Metadata_Category__get_Name(_) {
    return _.aName;
}

export function Metadata_Category__GetQualifiedColumnName(this$) {
    const tableName = defaultArg(this$["Shared.Metadata.Category.get_TableName"](), "texts");
    return `${tableName}.${this$["Shared.Metadata.Category.get_Code"]()}`;
}

export function Metadata_Category__GetGeoMapConfig(this$) {
    return new Metadata_GeoMapCategoryConfig(Metadata_Category__GetQualifiedColumnName(this$), Metadata_Category__get_Name(this$), this$["Shared.Metadata.Category.get_GeoMapControlType"]());
}

export class Metadata_StringCategory extends Metadata_Category {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_GeoMapControlType"]() {
        return new Metadata_GeoMapControlType(0);
    }
}

export function Metadata_StringCategory$reflection() {
    return class_type("Shared.Metadata.StringCategory", void 0, Metadata_StringCategory, Metadata_Category$reflection());
}

export function Metadata_StringCategory_$ctor_Z721C83C5(aName) {
    return new Metadata_StringCategory(aName);
}

export class Metadata_NumberCategory extends Metadata_Category {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_GeoMapControlType"]() {
        return new Metadata_GeoMapControlType(1);
    }
}

export function Metadata_NumberCategory$reflection() {
    return class_type("Shared.Metadata.NumberCategory", void 0, Metadata_NumberCategory, Metadata_Category$reflection());
}

export function Metadata_NumberCategory_$ctor_Z721C83C5(aName) {
    return new Metadata_NumberCategory(aName);
}

export class Metadata_LongTextCategory extends Metadata_Category {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_GeoMapControlType"]() {
        return new Metadata_GeoMapControlType(0);
    }
}

export function Metadata_LongTextCategory$reflection() {
    return class_type("Shared.Metadata.LongTextCategory", void 0, Metadata_LongTextCategory, Metadata_Category$reflection());
}

export function Metadata_LongTextCategory_$ctor_Z721C83C5(aName) {
    return new Metadata_LongTextCategory(aName);
}

export class Metadata_MenuState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Open", "Closed"];
    }
}

export function Metadata_MenuState$reflection() {
    return union_type("Shared.Metadata.MenuState", [], Metadata_MenuState, () => [[], []]);
}

export class Metadata_MenuItem extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CategoryMenu", "Section"];
    }
}

export function Metadata_MenuItem$reflection() {
    return union_type("Shared.Metadata.MenuItem", [], Metadata_MenuItem, () => [[["Item", Metadata_Category$reflection()]], [["Item1", Metadata_MenuState$reflection()], ["title", string_type], ["items", list_type(Metadata_MenuItem$reflection())]]]);
}

export class Metadata_CategoryMenuOption extends Record {
    constructor(Name, Value) {
        super();
        this.Name = Name;
        this.Value = Value;
    }
}

export function Metadata_CategoryMenuOption$reflection() {
    return record_type("Shared.Metadata.CategoryMenuOption", [], Metadata_CategoryMenuOption, () => [["Name", string_type], ["Value", string_type]]);
}

export class Metadata_CategoryType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["StringCategoryType", "NumberCategoryType"];
    }
}

export function Metadata_CategoryType$reflection() {
    return union_type("Shared.Metadata.CategoryType", [], Metadata_CategoryType, () => [[], []]);
}

export class Metadata_CategoryInfo extends Record {
    constructor(Name, Code, Type, Table) {
        super();
        this.Name = Name;
        this.Code = Code;
        this.Type = Type;
        this.Table = Table;
    }
}

export function Metadata_CategoryInfo$reflection() {
    return record_type("Shared.Metadata.CategoryInfo", [], Metadata_CategoryInfo, () => [["Name", string_type], ["Code", string_type], ["Type", Metadata_CategoryType$reflection()], ["Table", string_type]]);
}

export class Metadata_CategoryNameAndCode extends Record {
    constructor(Name, Code) {
        super();
        this.Name = Name;
        this.Code = Code;
    }
}

export function Metadata_CategoryNameAndCode$reflection() {
    return record_type("Shared.Metadata.CategoryNameAndCode", [], Metadata_CategoryNameAndCode, () => [["Name", string_type], ["Code", string_type]]);
}

export class Metadata_CategorySelection extends Record {
    constructor(Choices, ShouldExclude) {
        super();
        this.Choices = Choices;
        this.ShouldExclude = ShouldExclude;
    }
}

export function Metadata_CategorySelection$reflection() {
    return record_type("Shared.Metadata.CategorySelection", [], Metadata_CategorySelection, () => [["Choices", array_type(Metadata_CategoryMenuOption$reflection())], ["ShouldExclude", bool_type]]);
}

export function Metadata_CategorySelection_get_Default() {
    return new Metadata_CategorySelection([], false);
}

export class Metadata_SortDirection extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Asc", "Desc"];
    }
}

export function Metadata_SortDirection$reflection() {
    return union_type("Shared.Metadata.SortDirection", [], Metadata_SortDirection, () => [[], []]);
}

export class Metadata_SortInfo extends Record {
    constructor(CategoryCode, Direction) {
        super();
        this.CategoryCode = CategoryCode;
        this.Direction = Direction;
    }
}

export function Metadata_SortInfo$reflection() {
    return record_type("Shared.Metadata.SortInfo", [], Metadata_SortInfo, () => [["CategoryCode", string_type], ["Direction", Metadata_SortDirection$reflection()]]);
}

export class SearchEngine extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Cwb", "Fcs"];
    }
}

export function SearchEngine$reflection() {
    return union_type("Shared.SearchEngine", [], SearchEngine, () => [[], []]);
}

export class CorpusModality extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Spoken", "Written"];
    }
}

export function CorpusModality$reflection() {
    return union_type("Shared.CorpusModality", [], CorpusModality, () => [[], []]);
}

export class Language extends Record {
    constructor(Code, Name, TokenAttributes) {
        super();
        this.Code = Code;
        this.Name = Name;
        this.TokenAttributes = TokenAttributes;
    }
}

export function Language$reflection() {
    return record_type("Shared.Language", [], Language, () => [["Code", string_type], ["Name", string_type], ["TokenAttributes", option_type(list_type(Cwb_PositionalAttribute$reflection()))]]);
}

export class LanguageConfig extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Monolingual", "Multilingual"];
    }
}

export function LanguageConfig$reflection() {
    return union_type("Shared.LanguageConfig", [], LanguageConfig, () => [[["Item", option_type(list_type(Cwb_PositionalAttribute$reflection()))]], [["Item", array_type(Language$reflection())]]]);
}

export class ExternalTool extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["GoogleTranslate", "SaamiTranslate", "Voyant"];
    }
}

export function ExternalTool$reflection() {
    return union_type("Shared.ExternalTool", [], ExternalTool, () => [[], [], []]);
}

export class GeoMapConfig extends Record {
    constructor(CenterLat, CenterLng, ZoomLevel, MetadataCategories, LocationMetadataCategory) {
        super();
        this.CenterLat = CenterLat;
        this.CenterLng = CenterLng;
        this.ZoomLevel = ZoomLevel;
        this.MetadataCategories = MetadataCategories;
        this.LocationMetadataCategory = LocationMetadataCategory;
    }
}

export function GeoMapConfig$reflection() {
    return record_type("Shared.GeoMapConfig", [], GeoMapConfig, () => [["CenterLat", float64_type], ["CenterLng", float64_type], ["ZoomLevel", float64_type], ["MetadataCategories", list_type(Metadata_GeoMapCategoryConfig$reflection())], ["LocationMetadataCategory", Metadata_GeoMapCategoryConfig$reflection()]]);
}

export class SharedCorpusInfo extends Record {
    constructor(Code, DataFiles, ExternalTools, FontFamily, GeoCoordinates, GeoMapConfig, GoogleMapsApiKey, GoogleTranslateApiKey, HasMessages, Info, IsTreebank, LanguageConfig, Logo, Modality, MultiCpuBounds, Name, SearchEngine, ShowInfoBtnInSelectionPopup, TextsReferral, TotalTexts, TotalTokens) {
        super();
        this.Code = Code;
        this.DataFiles = DataFiles;
        this.ExternalTools = ExternalTools;
        this.FontFamily = FontFamily;
        this.GeoCoordinates = GeoCoordinates;
        this.GeoMapConfig = GeoMapConfig;
        this.GoogleMapsApiKey = GoogleMapsApiKey;
        this.GoogleTranslateApiKey = GoogleTranslateApiKey;
        this.HasMessages = HasMessages;
        this.Info = Info;
        this.IsTreebank = IsTreebank;
        this.LanguageConfig = LanguageConfig;
        this.Logo = Logo;
        this.Modality = Modality;
        this.MultiCpuBounds = MultiCpuBounds;
        this.Name = Name;
        this.SearchEngine = SearchEngine;
        this.ShowInfoBtnInSelectionPopup = ShowInfoBtnInSelectionPopup;
        this.TextsReferral = TextsReferral;
        this.TotalTexts = TotalTexts;
        this.TotalTokens = TotalTokens;
    }
}

export function SharedCorpusInfo$reflection() {
    return record_type("Shared.SharedCorpusInfo", [], SharedCorpusInfo, () => [["Code", string_type], ["DataFiles", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["ExternalTools", list_type(ExternalTool$reflection())], ["FontFamily", option_type(string_type)], ["GeoCoordinates", option_type(array_type(tuple_type(string_type, float64_type, float64_type)))], ["GeoMapConfig", option_type(GeoMapConfig$reflection())], ["GoogleMapsApiKey", option_type(string_type)], ["GoogleTranslateApiKey", option_type(string_type)], ["HasMessages", bool_type], ["Info", option_type(string_type)], ["IsTreebank", bool_type], ["LanguageConfig", LanguageConfig$reflection()], ["Logo", option_type(string_type)], ["Modality", CorpusModality$reflection()], ["MultiCpuBounds", option_type(array_type(array_type(class_type("System.Int64"))))], ["Name", string_type], ["SearchEngine", SearchEngine$reflection()], ["ShowInfoBtnInSelectionPopup", bool_type], ["TextsReferral", string_type], ["TotalTexts", class_type("System.Int64")], ["TotalTokens", class_type("System.Int64")]]);
}

export function SharedCorpusInfo_Init_20C0D908(code, name, modality, languageConfig, logo, multiCpuBounds, searchEngine, externalTools, geoMapConfig, textsReferral, dataFiles, isTreebank, showInfoBtnInSelectionPopup, hasMessages) {
    let derivedTextsReferral;
    if (textsReferral == null) {
        if (modality == null) {
            derivedTextsReferral = "texts";
        }
        else {
            const modality_1 = modality;
            derivedTextsReferral = ((modality_1.tag === 1) ? "texts" : "speakers");
        }
    }
    else {
        derivedTextsReferral = textsReferral;
    }
    return new SharedCorpusInfo(code, defaultArg(dataFiles, empty()), defaultArg(externalTools, empty_1()), void 0, void 0, defaultArg(geoMapConfig, void 0), void 0, void 0, defaultArg(hasMessages, false), void 0, defaultArg(isTreebank, false), defaultArg(languageConfig, new LanguageConfig(0, void 0)), logo, defaultArg(modality, new CorpusModality(1)), defaultArg(multiCpuBounds, void 0), name, defaultArg(searchEngine, new SearchEngine(0)), defaultArg(showInfoBtnInSelectionPopup, false), derivedTextsReferral, fromBits(0, 0, false), fromBits(0, 0, false));
}

export function SharedCorpusInfo__TryGetAttribute_Z721C83C5(this$, attrCode) {
    const matchValue = this$.LanguageConfig;
    if (matchValue.tag === 0) {
        if (matchValue.fields[0] == null) {
            return void 0;
        }
        else {
            const attributes = matchValue.fields[0];
            return tryFind((a) => (a.Code === attrCode), attributes);
        }
    }
    else {
        throw (new Error("NOT IMPLEMENTED!"));
    }
}

export function SharedCorpusInfo__HasAttribute_Z721C83C5(this$, attrCode) {
    const matchValue = this$.LanguageConfig;
    if (matchValue.tag === 0) {
        if (matchValue.fields[0] == null) {
            return false;
        }
        else {
            const attributes = matchValue.fields[0];
            return exists((a) => (a.Code === attrCode), attributes);
        }
    }
    else {
        throw (new Error("NOT IMPLEMENTED!"));
    }
}

export function SharedCorpusInfo__GetDefaultAttribute(this$) {
    return new Cwb_PositionalAttribute("word", SharedCorpusInfo__HasAttribute_Z721C83C5(this$, "orig") ? "Corrected form" : "Word form");
}

export class Query extends Record {
    constructor(HasFinalSpace, LanguageCode, QueryString) {
        super();
        this.HasFinalSpace = HasFinalSpace;
        this.LanguageCode = LanguageCode;
        this.QueryString = QueryString;
    }
}

export function Query$reflection() {
    return record_type("Shared.Query", [], Query, () => [["HasFinalSpace", bool_type], ["LanguageCode", option_type(string_type)], ["QueryString", string_type]]);
}

export function Query_Init_2297AD2E(languageCode) {
    return new Query(false, languageCode, "[]");
}

export function Query__get_IsEmpty(this$) {
    const query = this$.QueryString.trim();
    if (isNullOrWhiteSpace(query) ? true : (query === "\"\"")) {
        return true;
    }
    else {
        return isMatch(/^\[\](\s*\[\](\{\d*,\d*\})?)*$/g, query);
    }
}

export class SortKey extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Position", "Match", "Left", "Right"];
    }
}

export function SortKey$reflection() {
    return union_type("Shared.SortKey", [], SortKey, () => [[], [], [], []]);
}

export function SortKey_OfString_Z721C83C5(s) {
    switch (s) {
        case "Position": {
            return new SortKey(0);
        }
        case "Match": {
            return new SortKey(1);
        }
        case "Left": {
            return new SortKey(2);
        }
        case "Right": {
            return new SortKey(3);
        }
        default: {
            throw (new Error(`Unrecognized sort key: ${s}`));
        }
    }
}

export class SearchParams extends Record {
    constructor(ContextSize, CorpusCode, CpuCounts, End, LastCount, MetadataSelection, NumRandomHits, PageSize, Queries, RandomHitsSeed, SearchId, SortKey, Start, Step) {
        super();
        this.ContextSize = (ContextSize | 0);
        this.CorpusCode = CorpusCode;
        this.CpuCounts = CpuCounts;
        this.End = End;
        this.LastCount = LastCount;
        this.MetadataSelection = MetadataSelection;
        this.NumRandomHits = NumRandomHits;
        this.PageSize = (PageSize | 0);
        this.Queries = Queries;
        this.RandomHitsSeed = RandomHitsSeed;
        this.SearchId = (SearchId | 0);
        this.SortKey = SortKey;
        this.Start = Start;
        this.Step = (Step | 0);
    }
}

export function SearchParams$reflection() {
    return record_type("Shared.SearchParams", [], SearchParams, () => [["ContextSize", int32_type], ["CorpusCode", string_type], ["CpuCounts", option_type(array_type(class_type("System.Int64")))], ["End", class_type("System.Int64")], ["LastCount", option_type(class_type("System.Int64"))], ["MetadataSelection", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Metadata_CategorySelection$reflection()])], ["NumRandomHits", option_type(class_type("System.Int64"))], ["PageSize", int32_type], ["Queries", array_type(Query$reflection())], ["RandomHitsSeed", option_type(int32_type)], ["SearchId", int32_type], ["SortKey", SortKey$reflection()], ["Start", class_type("System.Int64")], ["Step", int32_type]]);
}

export function SearchParams_Init_Z7AD2BBF3(corpusConfig) {
    let languageCode;
    const matchValue = corpusConfig.LanguageConfig;
    if (matchValue.tag === 1) {
        const matchValue_1 = tryHead(matchValue.fields[0]);
        languageCode = ((matchValue_1 == null) ? (void 0) : matchValue_1.Code);
    }
    else {
        languageCode = (void 0);
    }
    return new SearchParams(corpusConfig.IsTreebank ? 25 : 15, corpusConfig.Code, void 0, fromBits(99, 0, false), void 0, empty(), void 0, 50, [Query_Init_2297AD2E(languageCode)], void 0, 0, new SortKey(0), fromBits(0, 0, false), 1);
}

export class SpeechSegment extends Record {
    constructor(Speaker, Line, From, To, IsMatch) {
        super();
        this.Speaker = Speaker;
        this.Line = Line;
        this.From = From;
        this.To = To;
        this.IsMatch = IsMatch;
    }
}

export function SpeechSegment$reflection() {
    return record_type("Shared.SpeechSegment", [], SpeechSegment, () => [["Speaker", string_type], ["Line", array_type(tuple_type(int32_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])))], ["From", string_type], ["To", string_type], ["IsMatch", bool_type]]);
}

export class MovieInfo extends Record {
    constructor(Supplied, Path, MovieLoc, Start, Stop) {
        super();
        this.Supplied = Supplied;
        this.Path = Path;
        this.MovieLoc = MovieLoc;
        this.Start = Start;
        this.Stop = Stop;
    }
}

export function MovieInfo$reflection() {
    return record_type("Shared.MovieInfo", [], MovieInfo, () => [["Supplied", string_type], ["Path", string_type], ["MovieLoc", string_type], ["Start", string_type], ["Stop", string_type]]);
}

export class MediaObject extends Record {
    constructor(Title, LastLine, DisplayAttribute, CorpusCode, Mov, Divs, StartAt, EndAt, MinStart, MaxEnd) {
        super();
        this.Title = Title;
        this.LastLine = (LastLine | 0);
        this.DisplayAttribute = DisplayAttribute;
        this.CorpusCode = CorpusCode;
        this.Mov = Mov;
        this.Divs = Divs;
        this.StartAt = (StartAt | 0);
        this.EndAt = (EndAt | 0);
        this.MinStart = (MinStart | 0);
        this.MaxEnd = (MaxEnd | 0);
    }
}

export function MediaObject$reflection() {
    return record_type("Shared.MediaObject", [], MediaObject, () => [["Title", string_type], ["LastLine", int32_type], ["DisplayAttribute", string_type], ["CorpusCode", string_type], ["Mov", MovieInfo$reflection()], ["Divs", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, SpeechSegment$reflection()])], ["StartAt", int32_type], ["EndAt", int32_type], ["MinStart", int32_type], ["MaxEnd", int32_type]]);
}

export class AudioType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Sound", "Nosound"];
    }
}

export function AudioType$reflection() {
    return union_type("Shared.AudioType", [], AudioType, () => [[], []]);
}

export class MediaPlayerType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AudioPlayer", "VideoPlayer", "WaveformPlayer"];
    }
}

export function MediaPlayerType$reflection() {
    return union_type("Shared.MediaPlayerType", [], MediaPlayerType, () => [[], [], []]);
}

export class SearchResult extends Record {
    constructor(AudioType, HasVideo, Text$) {
        super();
        this.AudioType = AudioType;
        this.HasVideo = HasVideo;
        this.Text = Text$;
    }
}

export function SearchResult$reflection() {
    return record_type("Shared.SearchResult", [], SearchResult, () => [["AudioType", option_type(AudioType$reflection())], ["HasVideo", bool_type], ["Text", list_type(string_type)]]);
}

export class SearchResultPage extends Record {
    constructor(PageNumber, Results) {
        super();
        this.PageNumber = (PageNumber | 0);
        this.Results = Results;
    }
}

export function SearchResultPage$reflection() {
    return record_type("Shared.SearchResultPage", [], SearchResultPage, () => [["PageNumber", int32_type], ["Results", array_type(SearchResult$reflection())]]);
}

export class SearchResultInfo extends Record {
    constructor(Count, CpuCounts, SearchId, SearchStep, ResultPages) {
        super();
        this.Count = Count;
        this.CpuCounts = CpuCounts;
        this.SearchId = (SearchId | 0);
        this.SearchStep = (SearchStep | 0);
        this.ResultPages = ResultPages;
    }
}

export function SearchResultInfo$reflection() {
    return record_type("Shared.SearchResultInfo", [], SearchResultInfo, () => [["Count", class_type("System.Int64")], ["CpuCounts", array_type(class_type("System.Int64"))], ["SearchId", int32_type], ["SearchStep", int32_type], ["ResultPages", array_type(SearchResultPage$reflection())]]);
}

export class TextAndTokenCounts extends Record {
    constructor(NumTexts, NumTokens) {
        super();
        this.NumTexts = NumTexts;
        this.NumTokens = NumTokens;
    }
}

export function TextAndTokenCounts$reflection() {
    return record_type("Shared.TextAndTokenCounts", [], TextAndTokenCounts, () => [["NumTexts", class_type("System.Int64")], ["NumTokens", class_type("System.Int64")]]);
}

export class DownloadFormat extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Multiline", "Excel", "Csv", "Tsv"];
    }
}

export function DownloadFormat$reflection() {
    return union_type("Shared.DownloadFormat", [], DownloadFormat, () => [[], [], [], []]);
}

export class AttributeValueDistribution extends Record {
    constructor(AttributeValue, MetadataValueFrequencies, AttributeValueTotal, Dp) {
        super();
        this.AttributeValue = AttributeValue;
        this.MetadataValueFrequencies = MetadataValueFrequencies;
        this.AttributeValueTotal = AttributeValueTotal;
        this.Dp = Dp;
    }
}

export function AttributeValueDistribution$reflection() {
    return record_type("Shared.AttributeValueDistribution", [], AttributeValueDistribution, () => [["AttributeValue", string_type], ["MetadataValueFrequencies", array_type(class_type("System.Int64"))], ["AttributeValueTotal", class_type("System.Int64")], ["Dp", float64_type]]);
}

export class CategoryValueStat extends Record {
    constructor(Value, CategoryValueTotal, TokenCount) {
        super();
        this.Value = Value;
        this.CategoryValueTotal = CategoryValueTotal;
        this.TokenCount = TokenCount;
    }
}

export function CategoryValueStat$reflection() {
    return record_type("Shared.CategoryValueStat", [], CategoryValueStat, () => [["Value", string_type], ["CategoryValueTotal", class_type("System.Int64")], ["TokenCount", class_type("System.Int64")]]);
}

export class MetadataDistribution extends Record {
    constructor(Distribution, CategoryValueStats, TotalTokenCount, TotalDp) {
        super();
        this.Distribution = Distribution;
        this.CategoryValueStats = CategoryValueStats;
        this.TotalTokenCount = TotalTokenCount;
        this.TotalDp = TotalDp;
    }
}

export function MetadataDistribution$reflection() {
    return record_type("Shared.MetadataDistribution", [], MetadataDistribution, () => [["Distribution", array_type(AttributeValueDistribution$reflection())], ["CategoryValueStats", list_type(CategoryValueStat$reflection())], ["TotalTokenCount", class_type("System.Int64")], ["TotalDp", float64_type]]);
}

export class FreqListTokenBoundaries extends Record {
    constructor(From, To) {
        super();
        this.From = From;
        this.To = To;
    }
}

export function FreqListTokenBoundaries$reflection() {
    return record_type("Shared.FreqListTokenBoundaries", [], FreqListTokenBoundaries, () => [["From", option_type(int32_type)], ["To", option_type(int32_type)]]);
}

export class TextSelectionInfo extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["TextSelectionInfo"];
    }
}

export function TextSelectionInfo$reflection() {
    return union_type("Shared.TextSelectionInfo", [], TextSelectionInfo, () => [[["Item", string_type]]]);
}

export function Route_builder(typeName, methodName) {
    return `/glossa3/api/${typeName}/${methodName}`;
}

export class IServerApi extends Record {
    constructor(GetCorpusConfig, GetCorpusList, GetMetadataForCategory, GetMinAndMaxForCategory, GetMetadataForTexts, GetMetadataForSingleText, GetTextAndTokenCount, SearchCorpus, GetSearchResults, DownloadSearchResults, GetMediaObject, GetGeoDistribution, GetFrequencyList, DownloadFrequencyList, GetMetadataDistribution, DownloadMetadataDistribution) {
        super();
        this.GetCorpusConfig = GetCorpusConfig;
        this.GetCorpusList = GetCorpusList;
        this.GetMetadataForCategory = GetMetadataForCategory;
        this.GetMinAndMaxForCategory = GetMinAndMaxForCategory;
        this.GetMetadataForTexts = GetMetadataForTexts;
        this.GetMetadataForSingleText = GetMetadataForSingleText;
        this.GetTextAndTokenCount = GetTextAndTokenCount;
        this.SearchCorpus = SearchCorpus;
        this.GetSearchResults = GetSearchResults;
        this.DownloadSearchResults = DownloadSearchResults;
        this.GetMediaObject = GetMediaObject;
        this.GetGeoDistribution = GetGeoDistribution;
        this.GetFrequencyList = GetFrequencyList;
        this.DownloadFrequencyList = DownloadFrequencyList;
        this.GetMetadataDistribution = GetMetadataDistribution;
        this.DownloadMetadataDistribution = DownloadMetadataDistribution;
    }
}

export function IServerApi$reflection() {
    return record_type("Shared.IServerApi", [], IServerApi, () => [["GetCorpusConfig", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [SharedCorpusInfo$reflection()]))], ["GetCorpusList", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(tuple_type(string_type, string_type))]))], ["GetMetadataForCategory", lambda_type(tuple_type(string_type, string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Metadata_CategorySelection$reflection()])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(string_type)]))], ["GetMinAndMaxForCategory", lambda_type(tuple_type(string_type, string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Metadata_CategorySelection$reflection()])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [tuple_type(class_type("System.Int64"), class_type("System.Int64"))]))], ["GetMetadataForTexts", lambda_type(tuple_type(string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Metadata_CategorySelection$reflection()]), list_type(string_type), int32_type, option_type(Metadata_SortInfo$reflection())), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(array_type(string_type))]))], ["GetMetadataForSingleText", lambda_type(tuple_type(string_type, list_type(Metadata_CategoryNameAndCode$reflection()), string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Metadata_CategoryMenuOption$reflection())]))], ["GetTextAndTokenCount", lambda_type(tuple_type(string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Metadata_CategorySelection$reflection()])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [tuple_type(TextAndTokenCounts$reflection(), TextSelectionInfo$reflection())]))], ["SearchCorpus", lambda_type(SearchParams$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [SearchResultInfo$reflection()]))], ["GetSearchResults", lambda_type(tuple_type(SearchParams$reflection(), class_type("System.Collections.Generic.IEnumerable`1", [int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(SearchResultPage$reflection())]))], ["DownloadSearchResults", lambda_type(tuple_type(SearchParams$reflection(), list_type(Cwb_PositionalAttribute$reflection()), list_type(Metadata_CategoryInfo$reflection()), DownloadFormat$reflection(), bool_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(uint8_type)]))], ["GetMediaObject", lambda_type(tuple_type(SearchParams$reflection(), MediaPlayerType$reflection(), int32_type, int32_type, int32_type, string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [tuple_type(MediaPlayerType$reflection(), int32_type, MediaObject$reflection())]))], ["GetGeoDistribution", lambda_type(SearchParams$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("System.Int64")])])]))], ["GetFrequencyList", lambda_type(tuple_type(SearchParams$reflection(), list_type(Cwb_PositionalAttribute$reflection()), bool_type, FreqListTokenBoundaries$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(string_type)]))], ["DownloadFrequencyList", lambda_type(tuple_type(SearchParams$reflection(), list_type(Cwb_PositionalAttribute$reflection()), bool_type, FreqListTokenBoundaries$reflection(), DownloadFormat$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(uint8_type)]))], ["GetMetadataDistribution", lambda_type(tuple_type(SearchParams$reflection(), string_type, string_type, Metadata_CategoryType$reflection(), bool_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [MetadataDistribution$reflection()]))], ["DownloadMetadataDistribution", lambda_type(tuple_type(SearchParams$reflection(), string_type, string_type, Metadata_CategoryType$reflection(), bool_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type]), DownloadFormat$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(uint8_type)]))]]);
}

